/**
 * B.H.
 */
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from "react-router-dom";
import PageShell from '../PageShell';
import { logout } from "../../features/user";
import axios from "axios";
import { API_URL, API_OK, API_EXCEPTION, DEFAULT_ERROR_TEXT, LIABILITY_POPUP_APPROVED, CATEGORY_VIEW_CATEGORIES_LIST, CATEGORY_VIEW_CATEGORY, APP_NAME_SIMKEHILOT, CALL_TYPE_ALL, CALL_TYPE_IN, CALL_TYPE_OUT, STATUS_OPEN, STATUS_BLOCKED, getActiveAppName } from '../../Constants';
import { Backdrop, CircularProgress, Typography} from '@mui/material';
import {Stack, Button, Box, Dialog, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../styles.css';
import cookie from "js-cookie";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { showErrorDialog } from "../../features/errorDialog";
import {handleApiErrorMessage, formatLocalPhone, isSectionDisabled, getBlockListPolicy} from "../../Helper";
import Switch from "../Switch";
import Category from "../Categories/Category";
import CategoriesGridWrapper from '../Categories/GridWrapper';
import BlockHistory from './BlockHistory';
import BlockNumberNotes from "../BlockNumberNotes";

const APP_NAME = getActiveAppName();


export default function CategoriesManagement(props) {
  const { t } = useTranslation();
  const [isNewCategoryDialogOpen, setIsNewCategoryDialogOpen] = useState(false);
  const [liabilityDialogIsOpen, setLiabilityDialogIsOpen] = useState(localStorage.getItem(LIABILITY_POPUP_APPROVED) !== "1");
  const [dontShowLiability, setDontShowLiability] = useState(false);
  const [deleteDialogIsOpen, setDeleteDialogIsOpen] = useState(false);
  const [removeBelongsDialogIsOpen, setRemoveBelongsDialogIsOpen] = useState(false);
  const [view, setView] = useState(CATEGORY_VIEW_CATEGORIES_LIST);
  const [expandedRowIds, setExpandedRowIds] = useState([]);
  
  const initalSelectedCategoryValue = {
    id: null,
    name: "",
    note: "",
    public: 1,
    privacy_level: 0,
    isOwner: 1,
    myJoin: 0,
    valid: 0,
    active_setting: 0
  };
  const [selectedCategory, setSelectedCategory] = useState(initalSelectedCategoryValue);
  const [selectedCategoryToDelete, setSelectedCategoryToDelete] = useState(initalSelectedCategoryValue);
  const [newCategoryValues, setNewCategoryValues] = useState(initalSelectedCategoryValue);

  const kehilaCategoryData = {
    id: 0,
    name: (APP_NAME === APP_NAME_SIMKEHILOT ? t('Kehila Category') : t('General category')),
    note: '',
    public: 0,
    create_date: '',
    isOwner: 1,
    myJoin: 1,
    valid: 1,
    active_setting: 0
  };

  const [categoriesExpanded, setCategoriesExpanded] = useState(false);
  const [scopeNoteOpen, setScopeNoteOpen] = useState(true);
  const [mobileTab, setMobileTab] = useState('lists'); // mobile: 'lists' | 'extra'
  const [mainTab, setMainTab] = useState('manage'); // top tabs: 'manage' | 'history'
  // קהילת פיקוח מנהלת חסימות בנפרד — "חסימה אקסטרה" אינה רלוונטית ואינה מוצגת כלל (סוג הקהילה אימיוטבילי, נשמר בכניסה).
  const isSupervision = localStorage.getItem('community_type') === 'SUPERVISION';
  // אם אין לקהילה גישה לרשימת המנויים — לא מציגים את הפניית "מעבר לניהול המנויים".
  const membersHidden = isSectionDisabled('members');
  // מדיניות הגדרות החסימה של הקהילה — מגבילה את האפשרויות בטופס ההוספה (נאכף גם קשיח בשרת).
  const blockPolicy = getBlockListPolicy();
  const allowStatusOpen = blockPolicy.status !== 'BLOCKED';
  const allowStatusBlocked = blockPolicy.status !== 'OPEN';
  const allowDirOut = blockPolicy.direction === 'BOTH' || blockPolicy.direction === 'OUT';
  const allowDirIn = blockPolicy.direction === 'BOTH' || blockPolicy.direction === 'IN';
  const allowDirAll = blockPolicy.direction === 'BOTH';

  // *111 / *112 dialing permissions (toggled here instead of the dashboard)
  const [dialPerms, setDialPerms] = useState(null);   // full permissions object
  const [savingDial, setSavingDial] = useState(null); // key being saved

  useEffect(() => {
    if (!scopeNoteOpen) return undefined;
    const id = setTimeout(() => setScopeNoteOpen(false), 5000);
    return () => clearTimeout(id);
  }, [scopeNoteOpen]);

  useEffect(() => {
    axios.get(API_URL + '/permissions', { headers: { token: cookie.get('token') } })
      .then(({ data }) => { if (data && data.responseStatus === API_OK) setDialPerms({ ...data.permissions }); })
      .catch(() => {});
  }, []);

  // mirrors the Dashboard's confirmChange flow exactly: PUT the full permissions
  // object, and commit to state only after the server confirms 'OK'.
  const toggleDialPerm = async (key) => {
    if (!dialPerms || savingDial) return;
    const updated = { ...dialPerms, [key]: !dialPerms[key] };
    setSavingDial(key);
    try {
      const { data } = await axios.put(API_URL + '/permissions', updated, { headers: { token: cookie.get('token') } });
      if (data.responseStatus === 'OK') {
        setDialPerms(updated);
        showSuccess(updated[key] ? 'ההרשאה הופעלה בהצלחה' : 'ההרשאה כובתה בהצלחה');
      } else {
        handleApiErrorMessage(data.message, t, dispatch, showErrorDialog, logout, navigate);
      }
    } catch {
      handleApiErrorMessage(t(DEFAULT_ERROR_TEXT), t, dispatch, showErrorDialog, logout, navigate);
    } finally {
      setSavingDial(null);
    }
  };
  const [quickAddOpen, setQuickAddOpen] = useState(false);
  // ברירות המחדל של טופס ההוספה נבחרות מתוך המותר במדיניות הקהילה (אחרת ה-select יציג ערך שאינו קיים באפשרויות).
  const initialQuickAdd = {
    number: '', active: '1',
    call_type: allowDirAll ? CALL_TYPE_ALL : (allowDirOut ? CALL_TYPE_OUT : CALL_TYPE_IN),
    status: allowStatusOpen ? STATUS_OPEN : STATUS_BLOCKED,
    note: '', actionNote: ''
  };
  const [quickAddValue, setQuickAddValue] = useState(initialQuickAdd);
  const [joinDialogCategory, setJoinDialogCategory] = useState(null);
  const [leaveDialogCategory, setLeaveDialogCategory] = useState(null);
  const [extraConfirm, setExtraConfirm] = useState(null); // 'enable' | 'disable' | null
  const [successMessage, setSuccessMessage] = useState(null);

  // ── "search a number across all of the community's block lists" ──
  // hits /monitorSearchBlockList; results let the user jump straight to the matching record.
  const [numberSearch, setNumberSearch] = useState('');
  const [numberSearchResults, setNumberSearchResults] = useState(null); // {number, rows, counts, truncated} | null
  const [numberSearchLoading, setNumberSearchLoading] = useState(false);
  const [numberSearchError, setNumberSearchError] = useState('');
  // when navigating from a search result into a category/main list, pre-filter its records to this number
  const [categoryInitialSearch, setCategoryInitialSearch] = useState('');

  const showSuccess = (msg) => {
    setSuccessMessage(msg);
    setTimeout(() => setSuccessMessage(null), 1800);
  };

  const [selectionIds, setSelectionIds] = useState([]);

  const initialSearchInput = {
    name : "",
    onlyOwner: false,
    onlyMy: false,
    onlyValid: false
  };
  const [searchInput, setSearchInput] = useState(initialSearchInput);

  const searchInputTypes = {
    name: "string",
    onlyOwner: "boolean",
    onlyMy: "boolean",
    onlyValid: "boolean"
  };

  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const DEAFULT_PAGE_SIZE = 20000;
  const [pageSize, setPageSize] = useState(DEAFULT_PAGE_SIZE);

  const [isUserBelongsToAllSelectedCategories, setIsUserBelongsToAllSelectedCategories] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if(loading){
      return () => {};
    }
    refreshCategoriesData();
  }, [page, pageSize, selectedCategory.id, view]);

  useEffect(() => {
    if(loading){
      return () => {};
    }
    for(let index = 0; index < rows.length; index++){
      if(!selectionIds.includes(rows[index].id)){
        continue;
      }
      if(rows[index].myJoin !== 1){
        setIsUserBelongsToAllSelectedCategories(false);
        return () => {};
      }
    }
    setIsUserBelongsToAllSelectedCategories(true);
  }, [selectionIds, rows]);

  
  const refreshCategoriesData = (pageToStart = null) => {
    if(pageToStart === null){
      pageToStart = page;
    }
    let errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }

    let currentPageSize = pageSize;
    if(pageToStart === 0){
      currentPageSize = pageSize-1;
    }
    let currentStart = pageToStart*pageSize;
    if(pageToStart > 0){
      currentStart = currentStart-1;
    }

    axios.post(API_URL + '/categories/list', 
    {
      start: currentStart, 
      limit: currentPageSize, 
      search: searchInput.name, 
      onlyOwner: searchInput.onlyOwner,
      onlyMy: searchInput.onlyMy,
      onlyValid: searchInput.onlyValid
    }, 
    {headers})
    .then(
      ({ data }) => {
        if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK && data.hasOwnProperty("list"))){
          let categoriesList = data.list;
          if(pageToStart === 0){
            kehilaCategoryData.active_setting = data.main_community_categories.active_setting;
            categoriesList.unshift(kehilaCategoryData);
          }
          setRows(categoriesList);
          setRowCount(data.totalCount+1);
          setLoading(false);
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
    });
  };

  const handleViewRow = (cellValues, initialNumberSearch = "") => {
    setCategoryInitialSearch(initialNumberSearch);
    setSelectedCategory({
      id: cellValues.id,
      name: cellValues.name,
      note: cellValues.note,
      isOwner: Number.parseInt(cellValues.isOwner),
      myJoin: Number.parseInt(cellValues.myJoin),
      valid: Number.parseInt(cellValues.valid),
      public: Number.parseInt(cellValues.public),
      privacy_level: Number.parseInt(cellValues.privacy_level),
      active_setting: Number.parseInt(cellValues.active_setting)
    });
    setView(CATEGORY_VIEW_CATEGORY);
  };

  // search a number across every block list the community can see (main list + its categories)
  const handleNumberSearch = () => {
    const term = numberSearch.trim();
    if (!term) return;
    setNumberSearchLoading(true);
    setNumberSearchError('');
    setNumberSearchResults(null);
    const headers = { token: cookie.get('token') };
    axios.post(API_URL + '/monitorSearchBlockList', { number: term }, { headers })
      .then(({ data }) => {
        if (data.responseStatus === API_OK && data.result) {
          setNumberSearchResults(data.result);
        } else {
          const msg = (data.responseStatus === API_EXCEPTION && data.message) ? data.message : t(DEFAULT_ERROR_TEXT);
          setNumberSearchError(msg);
          handleApiErrorMessage(msg, t, dispatch, showErrorDialog, logout, navigate);
        }
      })
      .catch(() => { setNumberSearchError(t(DEFAULT_ERROR_TEXT)); })
      .finally(() => setNumberSearchLoading(false));
  };

  const clearNumberSearch = () => {
    setNumberSearch('');
    setNumberSearchResults(null);
    setNumberSearchError('');
  };

  // jump from a search result to its record — open the source list, pre-filtered to the number
  const handleGoToRecord = (resultRow) => {
    const target = resultRow.source_type === 'MAIN'
      ? (rows.find(r => r.id === 0) || { ...kehilaCategoryData })
      : resultRow.category;
    if (!target) return;
    handleViewRow(target, String(resultRow.number));
  };
  
  const handleDeleteRow = (cellValues) => {
    setSelectedCategoryToDelete({
      id: cellValues.id,
      name: cellValues.name
    });
    setDeleteDialogIsOpen(true);
  };

  const handleRemoveBelongsRows = async () => {
    setRemoveBelongsDialogIsOpen(true);
  }

  const handleRemoveBelongsRowsSubmit = async () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    if(selectionIds.length === 0){
      alert(t('No lines selected'));
      return;
    }else{
      let nonRemovedRows = rows.filter((row) => (!selectionIds.includes(row.id)));
      if(nonRemovedRows.length === rows.length){
        alert(t('No lines selected'));
        return;
      }
    }
    
    setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }
    
      const data = {
        ids: selectionIds.map((id) => {return ''+id;})
      };

      let apiUrl = API_URL + '/categories/remove';

      axios.post(apiUrl, data, {headers})
      .then(
         (responseData) => {
          if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
            refreshCategoriesData();
            setSelectionIds([]);
          }else{
            if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
              errorMessage = responseData.data["message"];
            }
            handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          }
        }).catch((error) => {
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
      });
  };

  const handleJoinCategory = (id, successMsg) => {
    const errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);
    const headers = { token: cookie.get('token') };
    axios.post(API_URL + '/categories/add', { ids: ['' + id] }, { headers })
      .then(({ data }) => {
        if (data.responseStatus === API_OK) {
          showSuccess(successMsg || 'הקהילה נוספה לקטגוריה בהצלחה');
          refreshCategoriesData();
        } else {
          handleApiErrorMessage(data.message || errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch(() => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
      });
  };

  const handleLeaveCategory = (id, successMsg) => {
    const errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);
    const headers = { token: cookie.get('token') };
    axios.post(API_URL + '/categories/remove', { ids: ['' + id] }, { headers })
      .then(({ data }) => {
        if (data.responseStatus === API_OK) {
          showSuccess(successMsg || 'הקהילה הוסרה מהקטגוריה בהצלחה');
          refreshCategoriesData();
        } else {
          handleApiErrorMessage(data.message || errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch(() => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
      });
  };

  const handleQuickAddSubmit = () => {
    if (!quickAddValue.number.trim()) return;
    const errorMessage = t(DEFAULT_ERROR_TEXT);
    setLoading(true);
    setQuickAddOpen(false);
    const headers = { token: cookie.get('token') };
    const payload = { numbers: [{ number: quickAddValue.number.trim(), active: quickAddValue.active, call_type: quickAddValue.call_type, status: quickAddValue.status, note: quickAddValue.note }], actionNote: quickAddValue.actionNote };
    axios.post(API_URL + '/addBlockList', payload, { headers })
      .then(({ data }) => {
        if (data.responseStatus === API_OK) {
          setQuickAddValue(initialQuickAdd);
          showSuccess('המספר נוסף בהצלחה');
          refreshCategoriesData();
        } else {
          handleApiErrorMessage(data.message || errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch(() => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
      });
  };

  const handleAddBelongsRows = async () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    if(selectionIds.length === 0){
      alert(t('No lines selected'));
      return;
    }else{
      let nonRemovedRows = rows.filter((row) => (!selectionIds.includes(row.id)));
      if(nonRemovedRows.length === rows.length){
        alert(t('No lines selected'));
        return;
      }
    }
    
    setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }
    
    const data = {
      ids: selectionIds.map((id) => {return ''+id;})
    };

    let apiUrl = API_URL + '/categories/add';

    axios.post(apiUrl, data, {headers})
    .then(
        (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          setSelectionIds([]);
          refreshCategoriesData();
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
    });
  };

  const changeSearchFilters = (newValue, fieldName) => {
    let newSearchInput = {
      name : searchInput.name,
      onlyOwner: searchInput.onlyOwner,
      onlyMy: searchInput.onlyMy,
      onlyValid: searchInput.onlyValid
    };
    if(searchInputTypes[fieldName] === "boolean"){
      newValue = (newValue === "true" || newValue === true  ? true : false);
    }
    newSearchInput[fieldName] = newValue;
    
    setSearchInput(newSearchInput);
  };

  const handleSearchSubmit = (e) => {
    refreshCategoriesData(0);
  };

  const handleAddRow = () => {
    setNewCategoryValues(initalSelectedCategoryValue);
    setIsNewCategoryDialogOpen(true);
  }


  const handleCloseLiabilityDialog = () => {
    if (dontShowLiability) {
      localStorage.setItem(LIABILITY_POPUP_APPROVED, "1");
    }
    setLiabilityDialogIsOpen(false);
  }

  const handleDeleteRowSubmit = async () => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    setLoading(true);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/categories/'+selectedCategoryToDelete.id+'/delete';

    axios.get(apiUrl, {headers})
    .then(
        (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK){
          showSuccess('הקטגוריה נמחקה בהצלחה');
          refreshCategoriesData();
          setLoading(false);
          setDeleteDialogIsOpen(false);
        }else{
          if(responseData.data.responseStatus === API_EXCEPTION && responseData.data.hasOwnProperty("message")){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
    });
  };

  const handleChangeNewCategoryValue = (newValue, changedField) => {
    if(newValue === newCategoryValues[changedField]){
      return;
    }
    const newField = {[changedField] : newValue};
    setNewCategoryValues({...newCategoryValues, ...newField});
  }

  const createCategory = async (categoryData) => {
    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let  headers = {
      token: cookie.get('token')
    }

    let apiUrl = API_URL + '/categories/create';

    setLoading(true);

    await axios.post(apiUrl, {new_obj: categoryData}, {headers})
    .then(
      async (responseData) => {
        if(responseData.data.hasOwnProperty('responseStatus') && responseData.data.responseStatus === API_OK && responseData.data.hasOwnProperty('newCategorieId')){
          setLoading(false);
          setIsNewCategoryDialogOpen(false);
          setNewCategoryValues(initalSelectedCategoryValue);
          setSelectedCategory(initalSelectedCategoryValue);
        }else{
          if((responseData.data.responseStatus === API_EXCEPTION) && (responseData.data.hasOwnProperty("message"))){
            errorMessage = responseData.data["message"];
          }
          handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
          setLoading(false);
        }
      }).catch((error) => {
        handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate);
        setLoading(false);
    });

    refreshCategoriesData();
  };

  const handleCreateNewCategory = () => {
    const newCategoryData = {
      name: newCategoryValues.name,
      note: newCategoryValues.note,
      public: newCategoryValues.public,
      privacy_level: newCategoryValues.privacy_level
    };

    createCategory(newCategoryData);
  }

  const kehilaRow       = rows.find(r => r.id === 0);
  const contentRangesRow = rows.find(r => r.id === 53);
  const otherRows       = rows.filter(r => r.id !== 0 && r.id !== 53);
  const extraActive     = contentRangesRow?.myJoin === 1;

  // the API returns isOwner as "0"/"1" (string), valid/myJoin as numbers — coerce uniformly
  const numFlag = (v) => Number(v) === 1;
  // by default show the community's relevant lists: approved (valid) OR owned OR joined
  const myCategoryRows = otherRows.filter(r => numFlag(r.valid) || numFlag(r.isOwner) || numFlag(r.myJoin));
  // the rest are public categories the community can browse and join
  const discoverRows   = otherRows.filter(r => !(numFlag(r.valid) || numFlag(r.isOwner) || numFlag(r.myJoin)));

  // status badges for a category, driven purely by the API flags
  const renderCatBadges = (row) => (
    <div className="cat2-badges">
      {numFlag(row.valid) && (
        <span className="cat2-badge cat2-badge--valid" title="קטגוריה מאומתת על ידי המערכת">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          מאומתת
        </span>
      )}
      {numFlag(row.isOwner) && (
        <span className="cat2-badge cat2-badge--owner" title="הקטגוריה בבעלות הקהילה">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7l4 4 5-6 5 6 4-4v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
          בבעלותך
        </span>
      )}
      {numFlag(row.myJoin) && (
        <span className="cat2-badge cat2-badge--joined" title="הקהילה משויכת לקטגוריה">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/><path d="M16 11l2 2 4-4"/></svg>
          משויכת
        </span>
      )}
      {numFlag(row.privacy_level) && (
        <span className="cat2-badge cat2-badge--hidden" title="המספרים בקטגוריה מוסתרים">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          מוסתרת
        </span>
      )}
      {numFlag(row.public) && !numFlag(row.isOwner) && (
        <span className="cat2-badge cat2-badge--public" title="קטגוריה ציבורית הזמינה לכל הקהילות">ציבורית</span>
      )}
    </div>
  );

  // a single category row card (used both for "my lists" and "discover")
  const renderCatItem = (row) => (
    <div className={'cat2-item' + (numFlag(row.valid) ? ' cat2-item--valid' : '') + (numFlag(row.isOwner) ? ' cat2-item--owner' : '')} key={row.id}>
      <button type="button" className="cat2-item-main" onClick={() => handleViewRow(row)}>
        <span className="cat2-item-icon">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
        </span>
        <span className="cat2-item-body">
          <span className="cat2-item-name-row">
            <span className="cat2-item-name">{row.name}</span>
            {numFlag(row.valid) && (
              <span className="cat2-valid-check" title="קטגוריה מאומתת">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </span>
            )}
          </span>
          {row.note ? <span className="cat2-item-note" title={row.note}>{row.note}</span> : null}
          {renderCatBadges(row)}
        </span>
      </button>
      <div className="cat2-item-side">
        {Number.isFinite(Number(row.active_setting)) && Number(row.active_setting) > 0 && (
          <span className="cat2-item-count">{Number(row.active_setting).toLocaleString('he-IL')} מספרים</span>
        )}
        <div className="cat2-item-actions">
          {numFlag(row.myJoin) ? (
            <button
              className="cat2-act cat2-act--leave"
              disabled={row.allow_leave === 0}
              title={row.allow_leave === 0 ? 'לא ניתן להסיר קטגוריה זו' : 'הסרת הקהילה מהקטגוריה'}
              onClick={() => setLeaveDialogCategory(row)}
            >הסר</button>
          ) : (
            <button
              className="cat2-act cat2-act--join"
              disabled={row.allow_join === 0}
              title={row.allow_join === 0 ? 'לא ניתן להצטרף לקטגוריה זו' : 'צירוף הקהילה לקטגוריה'}
              onClick={() => setJoinDialogCategory(row)}
            >הצטרף</button>
          )}
          {/* delete is available only for categories the community owns */}
          {numFlag(row.isOwner) && (
            <button className="cat2-act cat2-act--del" onClick={() => handleDeleteRow(row)} title="מחיקת הקטגוריה">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <PageShell title="ניהול חסימות" subtitle="קטגוריות חסימות ורשימות מנויים">
    <>
    <div className="bm-tabs">
      <button className={'bm-tab' + (mainTab === 'manage' ? ' active' : '')} onClick={() => setMainTab('manage')}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        ניהול חסימות
      </button>
      <button className={'bm-tab' + (mainTab === 'history' ? ' active' : '')} onClick={() => setMainTab('history')}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><path d="M12 7v5l4 2"/></svg>
        היסטוריית חסימות
      </button>
    </div>

    {mainTab === 'history' ? <BlockHistory embedded /> : (
      view === CATEGORY_VIEW_CATEGORIES_LIST ?
      <>
      {/* scope notice popup — community-wide vs. per-subscriber block lists (hidden if no access to members) */}
      {scopeNoteOpen && !membersHidden && createPortal(
        <div className='ws-scope-pop'>
          <button className='ws-scope-pop-close' onClick={() => setScopeNoteOpen(false)} title='סגירה'>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <span className='ws-scope-pop-icon'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          </span>
          <span className='ws-scope-pop-text'>
            כאן מנהלים את רשימות החסימה עבור <strong>כל הקהילה</strong>. כדי להגדיר רשימת חסימה <strong>למנוי מסוים</strong>,&nbsp;
            <button type='button' className='ws-scope-pop-link' onClick={() => navigate('/customers-management')}>לחצו כאן</button>
            &nbsp;למעבר לניהול המנויים.
          </span>
          <span className='ws-scope-pop-bar'><i /></span>
        </div>,
        document.body
      )}

      {/* ── search a number across all of the community's block lists ── */}
      <div className="bsearch">
        <div className="bsearch-head">
          <span className="bsearch-head-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </span>
          <div className="bsearch-titles">
            <h3 className="bsearch-title">חיפוש מספר בכל רשימות החסימה</h3>
            <p className="bsearch-sub">בדקו היכן מספר מסוים מוגדר — ברשימת הקהילה או באחת מהקטגוריות שהקהילה רשאית לראות</p>
          </div>
        </div>

        <div className="bsearch-bar">
          <div className="bsearch-input-wrap">
            <svg className="bsearch-input-icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              className="bsearch-input"
              type="text"
              dir="ltr"
              placeholder="הקלידו מספר טלפון לחיפוש"
              value={numberSearch}
              onChange={(e) => { if (/^[0-9*+]*$/.test(e.target.value)) setNumberSearch(e.target.value); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleNumberSearch(); }}
            />
          </div>
          <button className="bsearch-btn" onClick={handleNumberSearch} disabled={numberSearchLoading || !numberSearch.trim()}>
            {numberSearchLoading ? (
              <span className="bsearch-btn-spin" />
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            )}
            חיפוש
          </button>
          {(numberSearchResults !== null || numberSearchError) && (
            <button className="bsearch-clear" onClick={clearNumberSearch} title="ניקוי החיפוש">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          )}
        </div>

        {numberSearchError && <div className="bsearch-error">{numberSearchError}</div>}

        {numberSearchResults !== null && (
          <div className="bsearch-results">
            {numberSearchResults.rows.length === 0 ? (
              <div className="bsearch-empty">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                <span>לא נמצאו רשומות עבור <strong dir="ltr">{formatLocalPhone(numberSearchResults.number)}</strong>.</span>
              </div>
            ) : (
              <>
                <div className="bsearch-summary">
                  נמצאו <strong>{numberSearchResults.counts.total}</strong> רשומות עבור <strong dir="ltr">{formatLocalPhone(numberSearchResults.number)}</strong>
                  {numberSearchResults.truncated && <span className="bsearch-trunc"> (מוצגות התוצאות הראשונות)</span>}
                </div>
                <div className="bsearch-list">
                  {numberSearchResults.rows.map((row) => (
                    <div className="bsearch-item" key={row.id}>
                      <div className="bsearch-item-info">
                        <div className="bsearch-item-top">
                          <span className={'bsearch-status' + (row.status === STATUS_BLOCKED ? ' is-blocked' : ' is-open')}>
                            {row.status === STATUS_BLOCKED ? 'חסום' : 'פתוח'}
                          </span>
                          <span className="bsearch-item-num" dir="ltr">{formatLocalPhone(row.number)}</span>
                          {row.isRange && <span className="bsearch-tag bsearch-tag--range" title="טווח / קידומת המכילה את המספר">טווח</span>}
                          {row.active === 0 && <span className="bsearch-tag bsearch-tag--inactive">לא פעיל</span>}
                        </div>
                        <div className="bsearch-item-bottom">
                          <span className={'bsearch-source' + (row.source_type === 'MAIN' ? ' is-main' : '')}>
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              {row.source_type === 'MAIN'
                                ? <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>
                                : <><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></>}
                            </svg>
                            {row.source_label}
                          </span>
                          {row.note && <span className="bsearch-note" title={row.note}>{row.note}</span>}
                        </div>
                      </div>
                      <button className="bsearch-goto" onClick={() => handleGoToRecord(row)}>
                        מעבר לרשומה
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>

      <div className="as2-mtabs">
        <button className={'as2-mtab' + (mobileTab === 'lists' ? ' active' : '')} onClick={() => setMobileTab('lists')}>רשימות הקהילה</button>
        {!isSupervision && <button className={'as2-mtab' + (mobileTab === 'extra' ? ' active' : '')} onClick={() => setMobileTab('extra')}>חסימה אקסטרה</button>}
      </div>
      <div className={'as2-grid as2-grid--' + mobileTab}>

        {/* ── Card 1: community numbers ── */}
        <div className="as2-card as2-card--lists">
          <div className="as2-card-head as2-card-head--inline">
            {kehilaRow && (
              <div className="cat-main-card" onClick={() => handleViewRow(kehilaRow)}>
                <div className="cat-main-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                </div>
                <div className="cat-main-info">
                  <div className="cat-main-name">{kehilaRow.name}</div>
                  <div className="cat-main-sub">קטגוריה ראשית — לחץ לצפייה בפרטים</div>
                </div>
                <svg className="cat-main-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              </div>
            )}
          </div>

          <div className="as2-chips-area">
            {loading && (
              <div className="as2-loading">
                <span className="as2-loading-spinner" />
                <span className="as2-loading-text">טוען רשימת קטגוריות</span>
              </div>
            )}
            {rows.length === 0 && !loading ? (
              <div className="as2-empty"><span className="as2-empty-icon">📭</span><span>אין קטגוריות</span></div>
            ) : (
              <>
                {/* actions row: add number (tall) + stacked load/create on the other side */}
                <div className="cat-actions-row">
                  <div className="cat-add-callout" onClick={() => { setQuickAddValue(initialQuickAdd); setQuickAddOpen(true); }}>
                    <div className="cat-add-bubble">לחץ כאן להוספת מספר לפתיחה או חסימה ברשימה של הקהילה בלבד</div>
                    <button className="cat-add-plus-btn" title="הוספת מספר">
                      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    </button>
                  </div>
                  <div className="cat-actions-col">
                    <button className="cat-new-category-btn" onClick={handleAddRow}>
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.5 1.5V13.5M13.5 7.5H1.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/></svg>
                      יצירת קטגוריה חדשה
                    </button>
                    {!categoriesExpanded ? (
                      discoverRows.length > 0 && (
                        <button className="cat-expand-btn" onClick={() => setCategoriesExpanded(true)}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></svg>
                          גלה קטגוריות נוספות להצטרפות ({discoverRows.length})
                        </button>
                      )
                    ) : (
                      <button className="cat-expand-btn cat-expand-btn--less" onClick={() => setCategoriesExpanded(false)}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
                        הסתר קטגוריות נוספות
                      </button>
                    )}
                  </div>
                </div>

                {/* ── My lists — always visible: approved / owned / joined ── */}
                {myCategoryRows.length > 0 && (
                  <div className="cat2-section">
                    <div className="cat2-section-head">
                      <span className="cat2-section-title">הרשימות שלך</span>
                      <span className="cat2-section-hint">רשימות מאושרות, בבעלות הקהילה, או שהקהילה משויכת אליהן</span>
                    </div>
                    <div className="cat2-list">
                      {myCategoryRows.map(row => renderCatItem(row))}
                    </div>
                  </div>
                )}

                {/* ── Discover — other public categories to join (behind the toggle) ── */}
                {categoriesExpanded && discoverRows.length > 0 && (
                  <div className="cat2-section">
                    <div className="cat-warn">
                      <div className="cat-warn-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                      </div>
                      <div className="cat-warn-text">
                        <strong>לקוחות יקרים, שימו לב</strong>
                        <p>כל קהילה יכולה להוסיף קטגוריית מספרים שמומלצים על ידה לפתיחה או חסימה. <strong>סים קהילות / סים מהדרין אינה לוקחת אחריות על טיב החסימה</strong>. <br />תוכלו בכל שלב להצטרף לאחת מהקטגוריות או להסיר אותה.</p>
                      </div>
                    </div>
                    <div className="cat2-list">
                      {discoverRows.map(row => renderCatItem(row))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

        </div>

        {/* ── right column: dial permissions + extra block ── */}
        <div className="as2-col-side">

        {/* *111 / *112 dialing permissions */}
        {dialPerms && (
          <div className="cat-dial-panel">
            <div className="cat-dial-panel-head">
              <span className="cat-dial-panel-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="5" cy="5" r="1.6"/><circle cx="12" cy="5" r="1.6"/><circle cx="19" cy="5" r="1.6"/><circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/><circle cx="5" cy="19" r="1.6"/><circle cx="12" cy="19" r="1.6"/><circle cx="19" cy="19" r="1.6"/></svg>
              </span>
              <h3 className="cat-dial-panel-title">חיוג לכוכביות שירות</h3>
            </div>

            <div className="cat-dial-list">
              <button
                className={'cat-dial-item' + (dialPerms.DIAL_111 ? ' is-allowed' : ' is-blocked')}
                disabled={!!savingDial}
                onClick={() => toggleDialPerm('DIAL_111')}>
                <span className="cat-dial-item-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                </span>
                <span className="cat-dial-item-name">כוכבית 111</span>
                <span className="cat-dial-state">{savingDial === 'DIAL_111' ? '…' : (dialPerms.DIAL_111 ? 'מאופשר' : 'חסום')}</span>
              </button>

              <button
                className={'cat-dial-item' + (dialPerms.BLOCK_USE_CUSTOMER_BLOCKS_REPORTS ? ' is-blocked' : ' is-allowed')}
                disabled={!!savingDial}
                onClick={() => toggleDialPerm('BLOCK_USE_CUSTOMER_BLOCKS_REPORTS')}>
                <span className="cat-dial-item-icon">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11H3v10h6V11zM21 3h-6v18h6V3zM15 7H9v14h6V7z"/></svg>
                </span>
                <span className="cat-dial-item-name">כוכבית 112</span>
                <span className="cat-dial-state">{savingDial === 'BLOCK_USE_CUSTOMER_BLOCKS_REPORTS' ? '…' : (dialPerms.BLOCK_USE_CUSTOMER_BLOCKS_REPORTS ? 'חסום' : 'מאופשר')}</span>
              </button>
            </div>
          </div>
        )}

        {/* ── Card 2: extra block (hidden entirely for supervision communities) ── */}
        {!isSupervision && (
        <div className={`as2-card as2-card--extra${extraActive ? ' as2-card--extra-active' : ''}`}>
          <div className="as2-card-head as2-card-head--extra">
            <div className={`as2-icon-wrap${extraActive ? ' as2-icon-wrap--gold' : ' as2-icon-wrap--gray'}`}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <div className="as2-card-titles">
              <h3 className="as2-card-title">חסימה אקסטרה</h3>
              <p className="as2-card-sub">הגנה מוגברת לקהילה</p>
            </div>
            <div className="as2-extra-action">
              <span className={`as2-extra-state${extraActive ? ' as2-extra-state--on' : ''}`}>
                {extraActive ? 'מופעל' : 'כבוי'}
              </span>
              <button
                className={`as2-toggle${extraActive ? ' as2-toggle--on' : ''}`}
                onClick={() => setExtraConfirm(extraActive ? 'disable' : 'enable')}
                disabled={loading}
                title={extraActive ? 'בטל הגנה מוגברת' : 'הפעל הגנה מוגברת'}
              >
                <span className="as2-toggle-thumb" />
              </button>
            </div>
          </div>

          <div className="as2-extra-body">
            <div className="as2-extra-info">
              <div className="as2-extra-info-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
              </div>
              <div className="as2-extra-info-body">
                <div className="as2-extra-info-title">מה זה חסימה אקסטרה?</div>
                <p className="as2-extra-info-text">
                  חסימה אקסטרה חוסמת עבור הקהילה <strong>טווחים שלמים של קווי תוכן</strong> (קווי נייעס, בידור וכדומה) הידועים כקווים לא רצויים. בהפעלת השירות, מנויי הקהילה לא יוכלו לחייג למספרים שבטווחים אלו, וכך הקהילה שמורה ומוגנת יותר.
                </p>
              </div>
            </div>

            <div className="as2-features as2-features--info">
              <div className="as2-feature">
                <div className="as2-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                </div>
                <div>
                  <div className="as2-feature-title">טווחי קווי תוכן חסומים</div>
                  <div className="as2-feature-sub">טווחי המספרים של קווי התוכן הידועים נחסמים אוטומטית עבור כלל מנויי הקהילה.</div>
                </div>
              </div>
              <div className="as2-feature">
                <div className="as2-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12l2 2 4-4"/><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                </div>
                <div>
                  <div className="as2-feature-title">הרשימה המורשית נשמרת</div>
                  <div className="as2-feature-sub">ההגנה אינה משפיעה על מספרים שהוספתם ידנית לרשימת המורשים של הקהילה.</div>
                </div>
              </div>
              <div className="as2-feature">
                <div className="as2-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="6" width="22" height="12" rx="6"/><circle cx="8" cy="12" r="3"/></svg>
                </div>
                <div>
                  <div className="as2-feature-title">הפעלה וכיבוי בכל עת</div>
                  <div className="as2-feature-sub">ניתן להפעיל או לבטל את החסימה בכל עת באמצעות המתג שבראש הכרטיס.</div>
                </div>
              </div>
            </div>

            {extraActive && (
              <div className="as2-extra-badge">
                <span>✓</span> ההגנה המוגברת פעילה
              </div>
            )}
          </div>
        </div>
        )}
        </div>

      </div>
      </>
      :
      <Category
        isDesktop={props.isDesktop}
        category={selectedCategory}
        initialNumberSearch={categoryInitialSearch}
        viewCategoriesList={() => {setView(CATEGORY_VIEW_CATEGORIES_LIST)}}
        loading={loading}
        setLoading={setLoading}
      />
    )}
    <Dialog open={deleteDialogIsOpen} onClose={() => {setDeleteDialogIsOpen(false)}} PaperProps={{ className: 'cat-dialog-paper' }}>
      <div className="cat-dialog">
        <div className="cat-dialog-head cat-dialog-head--danger">
          <div className="cat-dialog-icon cat-dialog-icon--danger">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </div>
          <div>
            <h3 className="cat-dialog-title">מחיקת קטגוריה</h3>
            <p className="cat-dialog-sub">{selectedCategoryToDelete.name}</p>
          </div>
          <button className="cat-dialog-close" onClick={() => setDeleteDialogIsOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="cat-dialog-body">
          <p className="cat-join-text">הקטגוריה <strong>{selectedCategoryToDelete.name}</strong> עומדת להימחק לצמיתות.</p>
          <p className="cat-join-text cat-join-text--sub">כל הלקוחות המשתמשים בקטגוריה זו יוסרו וכל רשימת החסימה תימחק. לא ניתן לשחזר קטגוריה שנמחקה.</p>
          <div className="cat-join-warning">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            <span>שימו לב!! פעולה זו הינה <strong>בלתי הפיכה</strong>.</span>
          </div>
        </div>
        <div className="cat-dialog-footer">
          <button className="cat-dialog-cancel" onClick={() => setDeleteDialogIsOpen(false)}>ביטול</button>
          <button className="cat-dialog-submit cat-dialog-submit--danger" onClick={handleDeleteRowSubmit}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>
            מחק קטגוריה
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog open={liabilityDialogIsOpen} onClose={handleCloseLiabilityDialog} PaperProps={{ className: 'ws-dialog-paper' }}>
      <div className='ws-notice'>
        <div className='ws-notice-icon'>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        </div>
        <h3 className='ws-notice-title'>לקוחות יקרים, שימו לב</h3>
        <p className='ws-notice-text'>כל קהילה יכולה להוסיף קטגוריית מספרים שמומלצים על ידה לפתיחה או חסימה. {t(APP_NAME)} אינה לוקחת אחריות על טיב החסימה. תוכלו בכל שלב להצטרף לאחת מהקטגוריות או להסיר אותה.</p>
        <label className='ws-notice-check'>
          <input type='checkbox' checked={dontShowLiability} onChange={(e) => setDontShowLiability(e.target.checked)} />
          <span className='ws-notice-check-box'>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </span>
          <span>אל תציג לי הודעה זאת שוב</span>
        </label>
        <button className='ws-notice-btn' onClick={handleCloseLiabilityDialog}>הבנתי</button>
      </div>
    </Dialog>
    <Dialog open={isNewCategoryDialogOpen} onClose={() => setIsNewCategoryDialogOpen(false)} PaperProps={{ className: 'bl-dialog-paper' }}>
      <div className='bl-dialog'>
        <div className='bl-dialog-header'>
          <div className='bl-dialog-icon'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/><line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/></svg>
          </div>
          <h3 className='bl-dialog-title'>{t("Create new category")}</h3>
          <button className='bl-dialog-close' onClick={() => setIsNewCategoryDialogOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className='bl-dialog-body'>
          <div className='bl-field'>
            <label htmlFor="cat-new-name">{t("Name")}</label>
            <input id="cat-new-name" type="text" className='bl-input' autoFocus
              placeholder={t("Name")}
              value={newCategoryValues.name}
              onChange={(e) => handleChangeNewCategoryValue(e.target.value, "name")}
            />
          </div>
          <div className='bl-field'>
            <label htmlFor="cat-new-note">{t("Description")}</label>
            <input id="cat-new-note" type="text" className='bl-input'
              placeholder={t("Description")}
              value={newCategoryValues.note}
              onChange={(e) => handleChangeNewCategoryValue(e.target.value, "note")}
            />
          </div>
          <div className='bl-toggle-field' onClick={() => handleChangeNewCategoryValue(String(newCategoryValues.public) === "1" ? "0" : "1", "public")}>
            <span>{t("Public")}</span>
            <button type='button' role='switch' aria-checked={String(newCategoryValues.public) === "1"}
              className={'bl-switch' + (String(newCategoryValues.public) === "1" ? ' on' : '')}
              onClick={(e) => { e.stopPropagation(); handleChangeNewCategoryValue(String(newCategoryValues.public) === "1" ? "0" : "1", "public"); }}>
              <span className='bl-switch-knob' />
            </button>
          </div>
          <div className='bl-toggle-field' onClick={() => handleChangeNewCategoryValue(String(newCategoryValues.privacy_level) === "1" ? "0" : "1", "privacy_level")}>
            <span>{t("Hide")} {t("the numbers in the list")}</span>
            <button type='button' role='switch' aria-checked={String(newCategoryValues.privacy_level) === "1"}
              className={'bl-switch' + (String(newCategoryValues.privacy_level) === "1" ? ' on' : '')}
              onClick={(e) => { e.stopPropagation(); handleChangeNewCategoryValue(String(newCategoryValues.privacy_level) === "1" ? "0" : "1", "privacy_level"); }}>
              <span className='bl-switch-knob' />
            </button>
          </div>
        </div>
        <div className='bl-dialog-footer'>
          <button className='bl-dialog-cancel' onClick={() => setIsNewCategoryDialogOpen(false)}>{t('Cancel')}</button>
          <button className='bl-dialog-submit' onClick={handleCreateNewCategory} disabled={!newCategoryValues.name}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            {t("Create new category")}
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog open={removeBelongsDialogIsOpen} 
      onClose={() => {
        setRemoveBelongsDialogIsOpen(false);
      }}
      className="confirm-dialog popup"
        >
        <div className='title'>
          <div className='text'>{t("Do you want to remove yourself from the category?")}</div>
        </div>
        <div className='content'>
          <div className='controls'>
              <div className='proceed'
              onClick={
                () => {
                  setRemoveBelongsDialogIsOpen(false);
                  setLoading(true);
                  handleRemoveBelongsRowsSubmit();
                }}
              >{t("Yes")}</div>
              <div className='cancel'
                onClick={() => {setRemoveBelongsDialogIsOpen(false)}}
              >{t("Cancel")}</div>
            </div>
        </div>
    </Dialog>
    <Dialog open={quickAddOpen} onClose={() => setQuickAddOpen(false)} PaperProps={{ className: 'bl-dialog-paper' }}>
      <div className="bl-dialog">
        <div className="bl-dialog-header">
          <div className="bl-dialog-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </div>
          <h3 className="bl-dialog-title">הוספת מספר לרשימה</h3>
          <button className="bl-dialog-close" onClick={() => setQuickAddOpen(false)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="bl-dialog-body">
          <div className="bl-field">
            <label htmlFor="comm-add-number">{t("Phone Number")}</label>
            <input id="comm-add-number" type="text" className="bl-input" dir="ltr" autoFocus
              placeholder={t("Phone Number")}
              value={quickAddValue.number}
              onChange={(e) => { if (/^[0-9*+]*$/.test(e.target.value)) setQuickAddValue({ ...quickAddValue, number: e.target.value }); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleQuickAddSubmit(); }}
            />
          </div>
          <BlockNumberNotes />
          <div className="bl-field-row">
            <div className="bl-field">
              <label htmlFor="comm-add-status">{t("Status")}</label>
              <select id="comm-add-status" value={quickAddValue.status} onChange={(e) => setQuickAddValue({ ...quickAddValue, status: e.target.value })}>
                {allowStatusBlocked && <option value={STATUS_BLOCKED}>{t("Blocked")}</option>}
                {allowStatusOpen && <option value={STATUS_OPEN}>{t("Open")}</option>}
              </select>
            </div>
            <div className="bl-field">
              <label htmlFor="comm-add-calltype">{t("Call Type")}</label>
              <select id="comm-add-calltype" value={quickAddValue.call_type} onChange={(e) => setQuickAddValue({ ...quickAddValue, call_type: e.target.value })}>
                {allowDirOut && <option value={CALL_TYPE_OUT}>{t("Outgoing call")}</option>}
                {allowDirIn && <option value={CALL_TYPE_IN}>{t("Incoming call")}</option>}
                {allowDirAll && <option value={CALL_TYPE_ALL}>{t("Both")}</option>}
              </select>
            </div>
          </div>
          <div className="bl-field">
            <label htmlFor="comm-add-note">{t("Note")}</label>
            <input id="comm-add-note" type="text" className="bl-input" value={quickAddValue.note} placeholder={t("Note")} onChange={(e) => setQuickAddValue({ ...quickAddValue, note: e.target.value })} />
          </div>
          <div className="bl-field">
            <label htmlFor="comm-add-actionnote">הערת ביצוע (אופציונלי)</label>
            <input id="comm-add-actionnote" type="text" className="bl-input" value={quickAddValue.actionNote} placeholder="הסיבה להוספה" onChange={(e) => setQuickAddValue({ ...quickAddValue, actionNote: e.target.value })} />
          </div>
          <div className="bl-toggle-field" onClick={() => setQuickAddValue({ ...quickAddValue, active: quickAddValue.active === "1" ? "0" : "1" })}>
            <span>{t("Is Active")}</span>
            <button type="button" role="switch" aria-checked={quickAddValue.active === "1"}
              className={'bl-switch' + (quickAddValue.active === "1" ? ' on' : '')}
              onClick={(e) => { e.stopPropagation(); setQuickAddValue({ ...quickAddValue, active: quickAddValue.active === "1" ? "0" : "1" }); }}>
              <span className="bl-switch-knob" />
            </button>
          </div>
        </div>
        <div className="bl-dialog-footer">
          <button className="bl-dialog-cancel" onClick={() => setQuickAddOpen(false)}>{t('Cancel')}</button>
          <button className="bl-dialog-submit" onClick={handleQuickAddSubmit} disabled={!quickAddValue.number.trim()}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            הוסף מספר
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog open={!!joinDialogCategory} onClose={() => setJoinDialogCategory(null)} PaperProps={{ className: 'cat-dialog-paper' }}>
      <div className="cat-dialog">
        <div className="cat-dialog-head">
          <div className="cat-dialog-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
          </div>
          <div>
            <h3 className="cat-dialog-title">הצטרפות לקטגוריה</h3>
            <p className="cat-dialog-sub">{joinDialogCategory?.name}</p>
          </div>
          <button className="cat-dialog-close" onClick={() => setJoinDialogCategory(null)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="cat-dialog-body">
          <p className="cat-join-text">הקהילה עומדת להצטרף לקטגוריה <strong>{joinDialogCategory?.name}</strong>.</p>
          <p className="cat-join-text cat-join-text--sub">כל המספרים שברשימת הקטגוריה יחולו על הקהילה.</p>
          {joinDialogCategory?.allow_leave === 0 && (
            <div className="cat-join-warning">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <span>שימו לב!! לאחר הוספת הקהילה לקטגוריה זו <strong>לא ניתן יהיה להסיר אותה</strong> — ההצטרפות הינה קבועה.</span>
            </div>
          )}
        </div>
        <div className="cat-dialog-footer">
          <button className="cat-dialog-cancel" onClick={() => setJoinDialogCategory(null)}>ביטול</button>
          <button className="cat-dialog-submit" onClick={() => { handleJoinCategory(joinDialogCategory.id); setJoinDialogCategory(null); }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            אישור והצטרפות
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog open={!!leaveDialogCategory} onClose={() => setLeaveDialogCategory(null)} PaperProps={{ className: 'cat-dialog-paper' }}>
      <div className="cat-dialog">
        <div className="cat-dialog-head">
          <div className="cat-dialog-icon cat-dialog-icon--danger">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="17" y1="11" x2="23" y2="11"/></svg>
          </div>
          <div>
            <h3 className="cat-dialog-title">הסרת קטגוריה</h3>
            <p className="cat-dialog-sub">{leaveDialogCategory?.name}</p>
          </div>
          <button className="cat-dialog-close" onClick={() => setLeaveDialogCategory(null)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="cat-dialog-body">
          <p className="cat-join-text">הקהילה עומדת לצאת מהקטגוריה <strong>{leaveDialogCategory?.name}</strong>.</p>
          <p className="cat-join-text cat-join-text--sub">המספרים שברשימת הקטגוריה לא יחולו יותר על הקהילה.</p>
        </div>
        <div className="cat-dialog-footer">
          <button className="cat-dialog-cancel" onClick={() => setLeaveDialogCategory(null)}>ביטול</button>
          <button className="cat-dialog-submit cat-dialog-submit--danger" onClick={() => { handleLeaveCategory(leaveDialogCategory.id); setLeaveDialogCategory(null); }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            הסר קטגוריה
          </button>
        </div>
      </div>
    </Dialog>
    <Dialog open={!!extraConfirm} onClose={() => setExtraConfirm(null)} PaperProps={{ className: 'cat-dialog-paper' }}>
      <div className="cat-dialog">
        <div className="cat-dialog-head">
          <div className={'cat-dialog-icon' + (extraConfirm === 'disable' ? ' cat-dialog-icon--danger' : '')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <div>
            <h3 className="cat-dialog-title">{extraConfirm === 'disable' ? 'ביטול חסימה אקסטרה' : 'הפעלת חסימה אקסטרה'}</h3>
            <p className="cat-dialog-sub">הגנה מוגברת לקהילה</p>
          </div>
          <button className="cat-dialog-close" onClick={() => setExtraConfirm(null)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="cat-dialog-body">
          {extraConfirm === 'disable' ? (
            <>
              <p className="cat-join-text">הקהילה עומדת לבטל את החסימה האקסטרה.</p>
              <p className="cat-join-text cat-join-text--sub">לאחר הביטול, מספרים שאינם ברשימה המורשית לא יסוננו אוטומטית.</p>
            </>
          ) : (
            <>
              <p className="cat-join-text">הקהילה עומדת להפעיל חסימה אקסטרה.</p>
              <p className="cat-join-text cat-join-text--sub">בהפעלת השירות, כל מספר שאינו ברשימה המורשית יעבור סינון אוטומטי והקהילה תהיה מוגנת מפני שיחות ספאם.</p>
              <p className="cat-join-text cat-join-text--sub">שימו לב כי החסימות הם בצורה גורפת לכלל הקידומות שיש בהם סיכון ללא יוצא מן הכלל!!</p>
            </>
          )}
        </div>
        <div className="cat-dialog-footer">
          <button className="cat-dialog-cancel" onClick={() => setExtraConfirm(null)}>ביטול</button>
          {extraConfirm === 'disable' ? (
            <button className="cat-dialog-submit cat-dialog-submit--danger" onClick={() => { handleLeaveCategory(53, 'חסימה אקסטרה בוטלה'); setExtraConfirm(null); }}>בטל הגנה</button>
          ) : (
            <button className="cat-dialog-submit" onClick={() => { handleJoinCategory(53, 'חסימה אקסטרה הופעלה בהצלחה'); setExtraConfirm(null); }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              הפעל הגנה
            </button>
          )}
        </div>
      </div>
    </Dialog>
    {successMessage && createPortal(
      <div className="cat-toast-overlay">
        <div className="cat-toast">
          <div className="cat-toast-check">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div className="cat-toast-text">{successMessage}</div>
        </div>
      </div>,
      document.body
    )}
    </>
    </PageShell>
  );
}
